module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "logo header__logo"
  }, [_c('span', {
    staticClass: "header__title"
  }, [_vm._v("\n      Aba.kg\n    ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bb7bbc7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sHeader.vue
// module id = 325
// module chunks = 1